import AppHeader from '../AppHeader'
import EsMyCardSubMenu from '../EsMyCardSubMenu'
import constant from '../../store/constant.js'
import { BrowserBackend } from '@sentry/browser'

export default {
  name: 'es-mycard-select_design',
  components: {
    AppHeader,
    EsMyCardSubMenu
  },
  data: () => ({
    loadError: false,
    mainDisplayCardBaseDesigns: [],
    cardHistory: [],
    allCardBaseDesign: [],
    getCardBaseDesignsEnd: false,
    swiperOption: {
      speed: 500,
      loop: true,
      pagination: {
        el: '.swiper-pagination'
      },
      autoplay: {
        disableOnInteraction: false
      }
    },
    usedDesignSwiperOption: {
      pagination: {
        el: '.swiper-pagination'
      }
    }
  }),
  created () {
    this.getCardBaseDesigns()
    this.checkForDraft()
  },
  computed: {
    getBackgroundImageByImageName () {
      return imageName => {
        return require(`../../../static/mycard/background/${imageName}.png`)
      }
    },
    getCharacter1ImageByImageName () {
      return (pathName, imageName) => {
        return require(`../../../static/mycard/character1/${pathName}/${imageName}.png`)
      }
    },
    getCharacter2ImageByImageName () {
      return imageName => {
        return require(`../../../static/mycard/character2/${imageName}.png`)
      }
    },
    swiper () {
      return this.$refs.mySwiper.swiper
    },
    historySwiper () {
      return this.$refs.historyMySwiper.swiper
    }
  },
  methods: {
    async getCardBaseDesigns () {
      let data = {}
      let res = null
      try {
        res = await this.$store.dispatch('GET_BASE_DESIGN', { data: data })
      } catch (err) {
        // 旧実装はエラーを握りつぶしてundefinedのまま後続処理に進んでいたため、
        // 通信に失敗すると例外で描画処理が止まり、画面が開かないままになっていた
        console.error(err)
        this.handleLoadError()
        return
      }
      if (!res) {
        this.handleLoadError()
        return
      }
      this.mainDisplayCardBaseDesigns = res.main_display_card_base_design || []
      let wkCardHistory = res.card_history || []
      let character1Find = 0
      let character2Find = 0
      let beforeBackgroundImage = ''
      let beforeCharacter1Image = ''
      let beforeCharacter2Image = ''
      let sameBackground = 0
      let sameCharacter1 = 0
      let sameCharacter2 = 0
      for (let i = 0; i < wkCardHistory.length; i++) {
        character1Find = 0
        character2Find = 0
        sameBackground = 0
        sameCharacter1 = 0
        sameCharacter2 = 0
        for (let j = 0; j < constant.character1Folder.length; j++) {
          if (constant.character1Folder[j] == wkCardHistory[i]["character_1_folder_path"]) {
            // キャラクター１のフォルダが削除されていない
            for (let k = 0; k < constant.character1Image[constant.character1Folder[j]].length; k++) {
              if (constant.character1Image[constant.character1Folder[j]][k] == wkCardHistory[i]["character_1_path"]) {
                // キャラクター１の画像が削除されていない
                character1Find = 1
                if (i !== 0) {
                  if (beforeCharacter1Image == wkCardHistory[i]["character_1_path"]) {
                    sameCharacter1 = 1
                  }
                } 
                beforeCharacter1Image = wkCardHistory[i]["character_1_path"]
                break;
              }
            }
          }
        }
        for (let l = 0; l < constant.character2Image.length; l++) {
          if (constant.character2Image[l] == wkCardHistory[i]["character_2_path"]) {
            // キャラクター２の画像が削除されていない
            character2Find = 1
            if (i !== 0) {
              if (beforeCharacter2Image == wkCardHistory[i]["character_2_path"]) {
                sameCharacter2 = 1
              }
            } 
            beforeCharacter2Image = wkCardHistory[i]["character_2_path"]
            break;
          }
        }
        if (i !== 0) {
          if (beforeBackgroundImage == wkCardHistory[i]["background_path"]) {
            sameBackground = 1
          }
        } 
        beforeBackgroundImage = wkCardHistory[i]["background_path"]
        if ((character1Find == 1 && character2Find == 1) &&
             (sameCharacter1 == 0 || sameCharacter2 == 0 || sameBackground == 0)) {
          this.cardHistory.push(wkCardHistory[i])
        }
      }
      this.allCardBaseDesign = res.all_card_base_design || []
      this.getCardBaseDesignsEnd = true
    },
    goPreview (baseCard) {
      this.$router.push({
        path: '/select_design/preview',
        query: {
          'background_path': baseCard.background_path,
          'character_1_folder_path': baseCard.character_1_folder_path,
          'character_1_path': baseCard.character_1_path,
          'character_2_path': baseCard.character_2_path
        }
      })
    },
    goPreviewByBaseCarousel () {
      this.$router.push({
        path: '/select_design/preview',
        query: {
          'background_path': this.mainDisplayCardBaseDesigns[this.swiper.realIndex].background_path,
          'character_1_folder_path': this.mainDisplayCardBaseDesigns[this.swiper.realIndex].character_1_folder_path,
          'character_1_path': this.mainDisplayCardBaseDesigns[this.swiper.realIndex].character_1_path,
          'character_2_path': this.mainDisplayCardBaseDesigns[this.swiper.realIndex].character_2_path
        }
      })
    },
    goPreviewByHistoryCarousel () {
      this.$router.push({
        path: '/select_design/preview',
        query: {
          'background_path': this.cardHistory[this.historySwiper.realIndex].background_path,
          'character_1_folder_path': this.cardHistory[this.historySwiper.realIndex].character_1_folder_path,
          'character_1_path': this.cardHistory[this.historySwiper.realIndex].character_1_path,
          'character_2_path': this.cardHistory[this.historySwiper.realIndex].character_2_path
        }
      })
    },
    handleLoadError () {
      // 白画面のままにせず、原因を伝えてホームに戻す
      if (this.loadError) {
        return
      }
      this.loadError = true
      alert('通信エラーが発生したニャン。もう一度お試しくださいニャン。')
      this.$router.push({ path: '/' })
    },
    checkForDraft () {
      const draftData = localStorage.getItem('es_mycard_draft')
      if (draftData) {
        this.$nextTick(() => {
          document.getElementById('draftModalButton').click()
        })
      }
    },
    resumeDraft () {
      const draftData = JSON.parse(localStorage.getItem('es_mycard_draft'))
      localStorage.removeItem('es_mycard_draft')
      sessionStorage.setItem('es_mycard', JSON.stringify(draftData))
      document.getElementById('draftModal').style.display = 'none'
      document.querySelector('.modal-backdrop').remove()
      document.body.classList.remove('modal-open')
      this.$router.push({ path: '/es_mycard/new' })
    },
    startFresh () {
      localStorage.removeItem('es_mycard_draft')
      document.getElementById('draftModal').style.display = 'none'
      document.querySelector('.modal-backdrop').remove()
      document.body.classList.remove('modal-open')
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/scripts/es-mycard-select_design.js